"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var _1 = require("./");
var VuexHistory_1 = require("./VuexHistory");
// tslint:disable-next-line
var DEFAULT_FILTER = function (mutation) {
    return true;
};
// tslint:disable-next-line
var DEFAULT_RESOLVE = function (mutation) {
    return [this.options.histories.keys[0]];
};
// tslint:disable-next-line
var DEFAULT_SERIALIZE = function (historyKey, state) {
    return state;
};
// tslint:disable-next-line
var DEFAULT_DESERIALIZE = function (historyKey, stateData, state) {
    return stateData;
};
exports.DEFAULT_KEY = 'default';
var generateDefaultOptions = function () {
    return {
        debug: false,
        size: 50,
        filter: DEFAULT_FILTER,
        histories: {
            keys: [exports.DEFAULT_KEY],
            resolve: DEFAULT_RESOLVE,
        },
        transform: {
            serialize: DEFAULT_SERIALIZE,
            deserialize: DEFAULT_DESERIALIZE,
        },
    };
};
var VuexMultiHistory = /** @class */ (function () {
    function VuexMultiHistory(options) {
        var _this = this;
        this.hasInstalled = false;
        this.options = Object.assign(generateDefaultOptions(), options);
        this.validateOptions();
        var dataObj = {
            historyMap: {},
        };
        for (var _i = 0, _a = this.options.histories.keys; _i < _a.length; _i++) {
            var key = _a[_i];
            dataObj.historyMap[key] = new VuexHistory_1.VuexHistory(this, key);
        }
        this.data = vue_1.default.observable(dataObj);
        this.plugin = function (store) {
            _this.store = store;
            _this.validateOptions();
            for (var key in _this.data.historyMap) {
                if (_this.data.historyMap.hasOwnProperty(key)) {
                    _this.data.historyMap[key].init();
                }
            }
            store.subscribe(function (mutation, state) {
                if (_this.options.filter && !_this.options.filter.call(_this, mutation)) {
                    return;
                }
                var resolvedHistoryKeys = _this.options.histories.resolve.call(_this, mutation);
                var localHistoryKeys = Object.keys(_this.data.historyMap);
                for (var _i = 0, resolvedHistoryKeys_1 = resolvedHistoryKeys; _i < resolvedHistoryKeys_1.length; _i++) {
                    var resolvedHistoryKey = resolvedHistoryKeys_1[_i];
                    if (!_this.data.historyMap[resolvedHistoryKey]) {
                        var keysString = localHistoryKeys.join(', ');
                        throw new Error("'" + resolvedHistoryKey + "' is not a valid key! Valid keys are: [" + keysString + "]}");
                    }
                    var history_1 = _this.getHistory(resolvedHistoryKey);
                    var snapshot = {
                        mutation: mutation.type,
                        stateData: _this.serialize(resolvedHistoryKey, state),
                    };
                    history_1.addSnapshot(snapshot);
                }
            });
            store.addHistory = _this.addHistory.bind(_this);
            store.hasHistory = _this.hasHistory.bind(_this);
            store.history = _this.getHistory.bind(_this);
            store.listHistoryKeys = _this.listHistoryKeys.bind(_this);
            store.removeHistory = _this.removeHistory.bind(_this);
            _this.hasInstalled = true;
        };
    }
    VuexMultiHistory.prototype.addHistory = function (historyKey) {
        if (this.data.historyMap[historyKey]) {
            return;
        }
        var history = new VuexHistory_1.VuexHistory(this, historyKey);
        if (this.hasInstalled) {
            history.init();
        }
        vue_1.default.set(this.data.historyMap, historyKey, history);
        return history;
    };
    VuexMultiHistory.prototype.hasHistory = function (historyKey) {
        return !!this.data.historyMap[historyKey];
    };
    VuexMultiHistory.prototype.getHistory = function (historyKey) {
        var key = historyKey || this.options.histories.keys[0];
        if (!this.data.historyMap[key]) {
            throw new Error("Cannot retrieve history for key '" + key + "'");
        }
        return this.data.historyMap[key];
    };
    VuexMultiHistory.prototype.listHistoryKeys = function () {
        return Object.keys(this.data.historyMap);
    };
    VuexMultiHistory.prototype.removeHistory = function (historyKey) {
        if (!this.data.historyMap[historyKey]) {
            return;
        }
        var history = this.data.historyMap[historyKey];
        vue_1.default.delete(this.data.historyMap, historyKey);
        return history;
    };
    VuexMultiHistory.prototype.serialize = function (historyKey, state) {
        return this.removeObservers(this.options.transform.serialize.call(this, historyKey, state));
    };
    VuexMultiHistory.prototype.deserialize = function (historyKey, stateData) {
        return this.removeObservers(this.options.transform.deserialize.call(this, historyKey, stateData, this.store.state));
    };
    VuexMultiHistory.prototype.validateOptions = function () {
        var errors = [];
        var size = this.options.size;
        if (typeof size !== 'number') {
            errors.push(new _1.InvalidTypeError('size', 'number'));
        }
        else if (size <= 0) {
            errors.push(new _1.InvalidValueError('size', 'has to be greater than zero'));
        }
        var filter = this.options.filter;
        if (typeof filter !== 'function') {
            errors.push(new _1.InvalidTypeError('filter', 'function'));
        }
        var _a = this.options.histories, resolve = _a.resolve, keys = _a.keys;
        if (typeof resolve !== 'function') {
            errors.push(new _1.InvalidTypeError('resolve', 'function'));
        }
        if (typeof keys !== 'object' || !Array.isArray(keys)) {
            errors.push(new _1.InvalidTypeError('keys', 'array'));
        }
        var _b = this.options.transform, serialize = _b.serialize, deserialize = _b.deserialize;
        if (typeof serialize !== 'function') {
            errors.push(new _1.InvalidTypeError('serialize', 'function'));
        }
        if (typeof deserialize !== 'function') {
            errors.push(new _1.InvalidTypeError('deserialize', 'function'));
        }
        if (errors.length > 0) {
            var introLine = "The following errors occurred when validating the options of 'VuexMultiHistory':";
            throw new (_1.InvalidOptionsError.bind.apply(_1.InvalidOptionsError, __spreadArrays([void 0, introLine], errors)))();
        }
    };
    VuexMultiHistory.prototype.removeObservers = function (obj) {
        return JSON.parse(JSON.stringify(obj));
    };
    return VuexMultiHistory;
}());
exports.VuexMultiHistory = VuexMultiHistory;
